import { ActionTypes } from "../constants/actionTypes";
const initialState = {
    requestInProgress: false,
    notifications: [],
    unreadCount: 0,
    error: null,
    isFollowing: false,
    followRequestInProgress: false,
}

export function notificationReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ADD_NOTIFICATION: {
            // the same notification can arrive via both the socket push and the reconnect refetch
            const others = state.notifications.filter(n => n.id !== action.payload.id)
            const notifications = [action.payload, ...others]
            return {
                ...state,
                notifications,
                unreadCount: notifications.filter(n => !n.is_read).length
            };
        }
        case ActionTypes.FETCH_NOTIFICATION_REQUEST:
            return { ...state, requestInProgress: true }
        case ActionTypes.FETCH_NOTIFICATION_SUCCESS:
            return { ...state, requestInProgress: false, notifications: action.payload, unreadCount: action.payload.filter(n => !n.is_read).length }
        case ActionTypes.FETCH_NOTIFICATION_FAILURE:
            return { ...state, requestInProgress: false, error: action.error }
        case ActionTypes.MARK_NOTIFICATION_READ_REQUEST:
            return { ...state, requestInProgress: true }
        case ActionTypes.MARK_NOTIFICATION_READ_SUCCESS:
            const updateNotifications = state.notifications.map(n => n.id === action.id ? { ...n, is_read: true } : n)
            return { ...state, requestInProgress: false, notifications: updateNotifications, unreadCount: updateNotifications.filter(n => !n.is_read).length }
        case ActionTypes.MARK_NOTIFICATION_READ_FAILURE:
            return { ...state, requestInProgress: false, error: action.error }
        case ActionTypes.CLEAR_UNREAD_REQUEST:
            return { ...state, requestInProgress: true }
        case ActionTypes.CLEAR_UNREAD_SUCCESS:
            const clearedNotifiations = state.notifications.map(n => ({ ...n, is_read: true }))
            return { ...state, requestInProgress: false, notifications: clearedNotifiations, unreadCount: 0 }
        case ActionTypes.CLEAR_UNREAD_FAILURE:
            return { ...state, requestInProgress: false, error: action.error }
        case ActionTypes.COMP_CHECK_REQUEST:
            return { ...state, followRequestInProgress: true }
        case ActionTypes.COMP_CHECK_SUCCESS:
            return { ...state, followRequestInProgress: false, isFollowing: Boolean(action.payload && action.payload.subscribed) }
        case ActionTypes.COMP_CHECK_FAILURE:
            return { ...state, followRequestInProgress: false, error: action.error }
        case ActionTypes.FOLLOW_COMPETITOR_REQUEST:
        case ActionTypes.UNFOLLOW_COMPETITOR_REQUEST:
            return { ...state, followRequestInProgress: true }
        case ActionTypes.FOLLOW_COMPETITOR_SUCCESS:
        case ActionTypes.UNFOLLOW_COMPETITOR_SUCCESS: {
            // the follow endpoint toggles; trust its subscribed flag when present, otherwise flip
            const subscribed = action.payload && typeof action.payload.subscribed === "boolean"
                ? action.payload.subscribed
                : !state.isFollowing
            return { ...state, followRequestInProgress: false, isFollowing: subscribed }
        }
        case ActionTypes.FOLLOW_COMPETITOR_FAILURE:
        case ActionTypes.UNFOLLOW_COMPETITOR_FAILURE:
            return { ...state, followRequestInProgress: false, error: action.error }
        default:
            return state;
    }
}